export const HideMainLoading = () => {
    document.body.classList.remove('b4K2Dx');
    // @ts-ignore
    document.querySelector('.mK76wQ')!.style.display = 'none';
};

export const ShowProgressLoading = () => {
    document.querySelector('.m7j2Gr')!.classList.add('active');
};

export const HideProgressLoading = () => {
    document.querySelector('.m7j2Gr')!.classList.remove('active');
};